import { AccountMemberSession } from "./AccountMember";
import { User } from "./User";

export interface Token {
    access_token: string;
    expiration: number;
    expires_in: number;
    token_type: string;
    user: User;
    /** CU-86ak84mj6 — refresh rotativo. Ausente nas respostas antigas do backend. */
    refresh_token?: string;
    refresh_expires_in?: number;
    /**
     * CU-17tm466h1cm — presente só quando quem logou é MEMBRO da conta. O
     * `user` acima continua sendo a conta (o dono): plano, créditos e flags.
     */
    member?: AccountMemberSession;
}

/**
 * Resposta do login quando a senha está correta mas ainda falta o segundo fator
 * (CU-86ak84mj6). Não traz `access_token`: a sessão só nasce depois do código.
 */
export interface TwoFactorChallenge {
    two_factor: 'required' | 'setup_required';
    two_factor_token: string;
    expires_in: number;
}

/** Material de cadastro do autenticador. */
export interface TwoFactorSetup {
    secret: string;
    otpauth_url: string;
    /** SVG em data-URI, gerado no backend — o painel não precisa de lib de QR. */
    qr_code: string;
}

/**
 * Material devolvido quando um administrador liga o segundo fator de outra
 * conta. Chega uma única vez: o segredo não é recuperável depois.
 */
export interface TwoFactorProvision extends TwoFactorSetup {
    message: string;
    was_enabled: boolean;
    recovery_codes: string[];
}

export function isTwoFactorChallenge(response: any): response is TwoFactorChallenge {
    return !!response && !!response.two_factor && !response.access_token;
}

/** Estado do segundo fator da conta logada (tela de perfil). */
export interface TwoFactorStatus {
    enabled: boolean;
    /**
     * Obrigatório para o perfil — Administrador e Customer Success. Bloqueia
     * desativar. Os campos de prazo saíram na CU-86akgt7pf junto com a data de
     * corte: de agência para baixo a ativação é voluntária.
     */
    required: boolean;
    confirmed_at: string | null;
    recovery_codes_remaining: number;
    /**
     * A pessoa clicou em "Não exibir mais" no aviso do dashboard. É da conta, e
     * não do navegador: quem dispensou não vê o aviso de novo em outro
     * computador. Não tem relação com `required` — o aviso é lembrete, a
     * obrigatoriedade é regra de perfil.
     */
    notice_dismissed: boolean;
}
